// extracted by mini-css-extract-plugin
export default {"Header":"Main_Header__mfE94","Main":"Main_Main__kCR8o","Footer":"Main_Footer__LfylU"};